import {useTranslation} from 'react-i18next';

import {isMobileDevice} from '../utils/isMobileDevice';

export const useShortcutTranslation = (letter: string): string | undefined => {
    const {t} = useTranslation();

    if (isMobileDevice()) {
        return undefined;
    }

    const platform = navigator.platform;
    if (platform.startsWith('Mac')) {
        return t('shortcuts.ctrl-cmd-letter', {
            defaultValue: '(Ctrl + \u2318 + {{letter}})',
            letter: letter.toUpperCase(),
        });
    }

    return t('shortcuts.ctrl-alt-letter', {
        defaultValue: '(Ctrl + Alt + {{letter}})',
        letter: letter.toUpperCase(),
    });
};
